<template>
    <div class="form-filter-active-chips flex flex-wrap items-center gap-1">
        <FormChip
            v-if="clearAll && selected?.length > 1"
            @click="clearAll"
            text="Clear All"
        >
            Clear All
        </FormChip>
        <FormChip
            v-if="selected?.length"
            v-for="value in selected"
            :key="key(value)"
            @click="toggleSelection(value)"
            :text="value.value"
        ></FormChip>
    </div>
</template>
<script>
export default {
    name: 'ContainerVideosFilterActiveChips',
    props: {
        clearAll: {
            required: false,
            type: Function,
        },
        toggleSelection: {
            required: true,
            type: Function,
        },
        selected: {
            required: true,
            type: Array
        }
    },
    methods: {
        key (value) {
            return `${value.field}-${value.value}`;
        }
    }
};
</script>
